module.exports = __webpack_public_path__ + "img/icon-filter.c5c112c3.png";